import React, { PureComponent } from 'react';
import { Button, message, Modal, Upload, Spin } from 'antd-v5';
import { UploadOutlined } from '@ant-design/icons';
import { generalParamsWithPToStr } from '../../../utils/math';
import request from '../../../utils/request';

class RepaymentImportResult extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errorVisible: false,
      errorMessageList: [],
    };
  }

  beforeUpload = (file) => {
    this.setState({ loading: true });
    const checkSize = file.size / 1024 / 1024 < 20;
    if (!checkSize) {
      message.error('单个文件不能超过20M!');
      this.setState({ loading: false });
    }
    return checkSize;
  };

  getErrorMessageList = (data) => {
    if (Array.isArray(data)) {
      return data;
    }

    if (Array.isArray(data?.errorMessageList)) {
      return data.errorMessageList;
    }
    return [];
  };

  showImportError = (data, fallbackMessage = '导入失败') => {
    const errorMessageList = this.getErrorMessageList(data);
    this.setState({
      errorVisible: true,
      errorMessageList: errorMessageList.length > 0 ? errorMessageList : [fallbackMessage],
    });
  };

  render() {
    const { loading, errorVisible, errorMessageList } = this.state;
    const { visible, onClose, onRefresh } = this.props;

    const requestUrl = `payEntryData/summary/importRepaymentData?${generalParamsWithPToStr(
      'payEntryData/summary/importRepaymentData',
      {},
    )}`;

    const uploadContractProps = {
      className: 'uploader',
      accept: '.xls,.xlsx',
      name: 'file',
      listType: 'picture-card',
      beforeUpload: this.beforeUpload,
      showUploadList: false,
      maxCount: 1,
      customRequest: (options) => {
        const params = { file: options.file };
        this.setState({ loading: true });
        request({
          url: requestUrl,
          params,
          headers: 'form-data',
          method: 'post',
        })
          .then((res) => {
            this.setState({ loading: false });
            const { code, data } = res || {};
            if (code === 200) {
              const nextErrorMessageList = this.getErrorMessageList(data);
              onClose();
              if (nextErrorMessageList.length > 0) {
                this.setState({
                  errorVisible: true,
                  errorMessageList: nextErrorMessageList,
                });
                onRefresh?.();
                return;
              }

              Modal.success({
                title: '导入成功',
                content: data,
              });
              onRefresh?.();
            } else {
              onClose();
              this.showImportError(data, res?.msg);
            }
          })
          .catch((err) => {
            this.setState({ loading: false });
            message.error(err?.message || '导入失败');
          });
      },
    };

    return (
      <>
        <Modal
          title='导入回款'
          visible={visible}
          onOk={() => onClose()}
          onCancel={() => onClose()}
          destroyOnClose
          maskClosable={false}
          footer={[<Button onClick={() => onClose()}>关闭</Button>]}
        >
          <Spin spinning={loading}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Upload {...uploadContractProps}>
                <UploadOutlined />
                <p>点击此处选择文件</p>
              </Upload>
            </div>
          </Spin>
          <div>
            <p>1、仅支持Excel，单个文件不超过20M</p>
            <p>2、确保表格内只有一个工作簿，如果有多个工作簿只有第一个会被处理</p>
          </div>
        </Modal>
        <Modal
          title='导入结果提示'
          visible={errorVisible}
          onOk={() => this.setState({ errorVisible: false })}
          onCancel={() => this.setState({ errorVisible: false })}
          destroyOnClose
          footer={[
            <Button type='primary' onClick={() => this.setState({ errorVisible: false })}>
              我知道了
            </Button>,
          ]}
        >
          <h3>导入失败，错误信息如下：</h3>
          <div style={{ maxHeight: 360, overflowY: 'scroll' }}>
            {errorMessageList.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
        </Modal>
      </>
    );
  }
}

export default RepaymentImportResult;
